import { moveWidgetPluginAction } from './shared/widgetPlugin';

export default [moveWidgetPluginAction];
